import { routes } from "../config/api_routes";

export const AdminOrderService = {
    // getAllCustomer: () => window.axios.get(routes.getAllCustomerApi),
    getAllCustomer: (params = {}) => window.axios.get(routes.getAllCustomerApi, { params }),

    addCustomer: (formData) => window.axios.post(routes.postAddCustomerApi, formData),
    getCustomerVehicle: (formData) => window.axios.post(routes.getVehiclesApi,formData),
    Addvehicles: (formData) => window.axios.post(routes.addVehiclesApi, formData),
    getCustomerAddress: (formData) => window.axios.post(routes.getCustomerAddressApi, formData),
    addCustomerAddress: (formData) => window.axios.post(routes.addCustomerAddressApi,formData),
    getTimeSlot: (formData) => window.axios.post(routes.getTimeSlotApi,formData),
    adminSubmitOrder: (formData) => window.axios.post(routes.AdninOrderRequestApi,formData),
};
